import { Callback } from './../../pages-public/login/login.component';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DynamicFormDto,DynamicPayloadDto } from '../../service/dto';

export class FormResult {
	type!: 'Submit' | 'Cancel';
	data!: DynamicPayloadDto;
}

@Component({
	selector: 'app-dynamic-form',
	standalone: false,
	templateUrl: './dynamic-form.component.html',
	styleUrl: './dynamic-form.component.scss'
})
export class DynamicFormComponent {
	@Input()
	input?: DynamicFormDto;
	@Input()
	title!: string;
	@Output()
	result = new EventEmitter<FormResult>();
}
